// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"e1bdcd03","453":"64aababc","645":"c701628c","847":"bd519c14","954":"4962f6d5"}[chunkId] + ".chunk.js";
};